import { API } from '@shared/types/api';

export function keyExtractor(user: API.ShortUserFragment) {
  return String(user.id);
}
